<template>
  <div id="app">
    <!-- This will render the component based on the route -->
    <router-view v-slot="{ Component }">
      <keep-alive include="OrdersTableView">
            <component :is="Component" />
        </keep-alive>
    </router-view>
    <!-- App-wide operator chat bubble (visible on every route once logged in) -->
    <GlobalChatBubble />
  </div>
</template>

<script>
// No need to import UserLogin here since it will be handled by the router
import GlobalChatBubble from './components/GlobalChatBubble.vue';

export default {
  name: 'App',
  components: { GlobalChatBubble },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
